import { render, staticRenderFns } from "./leadsCanbanCard.vue?vue&type=template&id=70e3465e&"
import script from "./leadsCanbanCard.vue?vue&type=script&lang=js&"
export * from "./leadsCanbanCard.vue?vue&type=script&lang=js&"
import style0 from "./leadsCanbanCard.vue?vue&type=style&index=0&id=70e3465e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports